import { CTAQueryStateType } from '@sc/data-access-models';

export class CTAQuerySetAction {
  static readonly type = '[CTA Query] CTA Query Set';
  constructor(public ctaQuery: Partial<CTAQueryStateType>) {}
}

export class CTAQueryUnsetAction {
  static readonly type = '[CTA Query] CTA Query Unset';
}
